module.exports = __webpack_public_path__ + "static/media/homepage_logo.eb9cbf46.png";